import React from "react";
import {CLIENT_LOCALES, CLIENT_LOCALE_STRINGS} from "./constants";

const initialState = CLIENT_LOCALE_STRINGS[CLIENT_LOCALES.en]

const LocaleContext = React.createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case "CHANGE_CLIENT_LOCALE": {
            return CLIENT_LOCALE_STRINGS[action.payload.code]
        }
        default:
            return state;
    }
}

export const ClientLocaleProvider = ({ children }) => {
    const [state, dispatch] = React.useReducer(reducer, initialState);
    return (
        <LocaleContext.Provider value={{state, dispatch}}>
            {children}
        </LocaleContext.Provider>
    )
}

export const useClientLocale = () => {
    const context = React.useContext(LocaleContext);
    const { state, dispatch } = context;
    const changeClientLocale = (code) => {
        dispatch({
            type: "CHANGE_CLIENT_LOCALE",
            payload: {
                code,
            }
        });
    };
    return {
        strings: state,
        changeClientLocale,
    };
};